import React from 'react';
import './StakeholderCard.scss';

export type StakeholderCardProps = {
    number: number;
    firstname: string;
    lastname: string;
    email?: string;
    phone?: string;
    status?: string;
};

export const StakeholderCard: React.FC<StakeholderCardProps> = ({
    number,
    firstname,
    lastname,
    email,
    phone,
    status
}) => {
    return (
        <article className="stakeholder-card">
            <header className="stakeholder-card__badge">Proche N°{number}</header>
            <dl className="stakeholder-card__list">
                <div><dt>Prénom :</dt><dd>{firstname}</dd></div>
                <div><dt>Nom :</dt><dd>{lastname}</dd></div>
                {email && <div><dt>Adresse E-mail :</dt><dd>{email}</dd></div>}
                {phone && <div><dt>Numéro de téléphone :</dt><dd>{phone}</dd></div>}
                {status && <div><dt>Statut :</dt><dd>{status}</dd></div>}
            </dl>
        </article>
    );
};
